export default __webpack_public_path__ + "static/media/icon-c.757d9560.svg";